import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import EditTabProperties from '../../../inputs/EditTabProperties';
import AddListItemButton from '../../../inputs/AddListItemButton';
import { addTabProperty, deleteTabProperty } from '../../../actions/apiDealerUpdates';
import { addNewVehicleColumnID } from '../../../actions/apiDepartmentUpdates';

const EditSuperForm = (props) => {
    const [errors, setErrors] = useState({ addDepartmentPropertyError: false });
    const [optionName, setOptionName] = useState('');
    const dispatch = useDispatch();
    const { tab, vehicle_columns } = props;

    const addNewVehicleColumn = () => {
        const input_name = 'userstamp';
        const name = optionName;
        const errorType = 'add new vehicle column';
        const data = { name, input_name };

        return dispatch(addNewVehicleColumnID(data, errorType)).then((resp) => {
            setOptionName(''); // Reset optionName after adding
            return resp;
        });
    };

    const onChange = (e) => {
        setOptionName(e.target.value);
    };

    const onClick = () => {
        const errorType = 'addTabProperty';
        const vehicle_column = _.find(vehicle_columns, { name: optionName });

        if (vehicle_column) {
            const data = {
                vehicle_column_id: vehicle_column.id,
                tab_id: tab.id,
                name: optionName,
            };
            setOptionName(''); // Reset optionName after adding
            dispatch(addTabProperty(data, errorType));
        } else {
            addNewVehicleColumn().then((resp) => {
                const data = {
                    vehicle_column_id: resp,
                    tab_id: tab.id,
                    name: optionName,
                };
                setOptionName(''); // Reset optionName after adding
                dispatch(addTabProperty(data, errorType));
            }).catch(ex => console.error(ex));
        }
    };

    const onDelete = (e) => {
        const errorType = 'Delete Tab Property';
        const { id } = e.target.dataset;
        dispatch(deleteTabProperty(id, errorType));
    };

    return (
        <div className="col-md-12">
            <h3 className="text-center">SuperForm</h3>

            <div className="card space-top-1">
                <div className="card-text">
                    <h3>Top Row Checklist Settings</h3>
                    <div className="col-md-12">
                        <small>
                            <i className={'fa fa-info-circle text-info'} />
                            {' '}
                            Choose from an existing vehicle column or create a new column and then add it to the list.
                        </small>
                        <AddListItemButton 
                            field={'option_name'} 
                            value={optionName} 
                            label={'test'} 
                            error={errors.addDepartmentPropertyError} 
                            type={'text'} 
                            onChange={onChange} 
                            onClick={onClick} 
                        />
                    </div>

                    <table className="table table-striped table-sm">
                        <thead className={'thead text-center'}>
                            <tr>
                                <th>vehicle_column_id</th>
                                <th>order</th>
                                <th>name</th>
                                <th>label</th>
                                <th>required</th>
                                <th>lockable</th>
                                <th>notifications</th>
                                <th>key</th>
                                <th>value</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tab.tab_properties.map(tab_property => (
                                <tr key={`tab_property_${tab_property.id}`}>
                                    <td>{tab_property.vehicle_column_id}</td>
                                    <td>{tab_property.order}</td>
                                    <td>{tab_property.name}</td>
                                    <td>{tab_property.label}</td>
                                    <td>{tab_property.required ? 'Yes' : 'No'}</td>
                                    <td>{tab_property.lockable ? 'Yes' : 'No'}</td>
                                    <td>{tab_property.notifications ? 'Yes' : 'No'}</td>
                                    <td>{tab_property.key}</td>
                                    <td>{tab_property.value}</td>
                                    <td>
                                        <button className={'btn btn-danger btn-sm'} onClick={onDelete} data-id={tab_property.id}>X</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default EditSuperForm;
